import FixedLightBox from '../../../../components/FixedLightBox'
import PurchaseLightBoxHeader from './PurchaseLightBoxHeader'
import PurchaseLightBoxFooter from './PurchaseLightBoxFooter'
import PurchaseLightBoxContent from './PurchaseLightBoxContent'
import View from '../../../../View'
import {bindActionCreators} from 'redux'
import {connect} from '../../../../redux/utils'
import {getPurchaseStepNumber, getPurchaseSteps, getPurchaseStrategyType} from './selectors'
import {
    getFreeLicense,
    purchaseLicense,
    closePurchasePopup,
    sendCompanyInfo,
    setAgreementsConfirmed,
    setNextPurchaseStepNumber,
    setPrevPurchaseStepNumber,
} from './actions'

class PurchaseLightBox extends View {
    constructor({
        setPrevPurchaseStepNumber = () => {},
        setNextPurchaseStepNumber = () => {},
        sendCompanyInfo = () => {},
        getFreeLicense = () => {},
        purchaseLicense = () => {},
        closePurchasePopup = () => {},
        setAgreementsConfirmed = () => {},
    } = {}) {
        super()

        this.actions = {
            setPrevPurchaseStepNumber,
            setNextPurchaseStepNumber,
            sendCompanyInfo,
            getFreeLicense,
            purchaseLicense,
            closePurchasePopup,
            setAgreementsConfirmed,
        }

        this.state = {
            purchaseStepNumber: 0,
            steps: [],
            purchaseStrategyType: '',
        }

        this.onAnyStatePropertyChanged(['purchaseStepNumber', 'steps'], () => {
            const step = this.state.steps[this.state.purchaseStepNumber - 1]
            this.header.setState({
                purchaseStep: step,
                stepNumber: this.state.purchaseStepNumber,
                totalNumberSteps: this.state.steps.length - 1,
            })
            this.footer.setState({
                purchaseStep: step,
                totalNumberSteps: this.state.steps.length - 1,
            })
            this.content.setState({purchaseStep: step})
        })

        this.onStatePropertyChanged('purchaseStrategyType', (purchaseStrategyType) => {
            this.content.setState({purchaseStrategyType})
            this.header.setState({purchaseStrategyType})
            this.footer.setState({purchaseStrategyType})
        })
    }

    afterRender() {
        this.header = new PurchaseLightBoxHeader()
        this.content = new PurchaseLightBoxContent()
        this.footer = new PurchaseLightBoxFooter({
            companyInfoContinueButtonClick: this.actions.sendCompanyInfo,
            accountInfoContinueButtonClick: this.actions.setNextPurchaseStepNumber,
            getFreeLicenseButtonClick: this.actions.getFreeLicense,
            onPayButtonClick: () => this.actions.purchaseLicense(this.content.getStripeElements()),
            onBackButtonClick: this.actions.setPrevPurchaseStepNumber,
            onConfirmAgreementClick: this.actions.setAgreementsConfirmed,
        })

        this.lightBox = new FixedLightBox().init({
            id: 'purchaseLightBox',
            header: this.header,
            content: this.content,
            footer: this.footer,
            classNames: 'purchaseLightBox',
        })
        this.lightBox.setCancelCallback(() => {
            this.lightBox.hide()
            this.actions.closePurchasePopup()
            this.content.clearStripeElements()
        })
    }

    show() {
        this.lightBox.show()
    }
}

export default connect(
    (state) => ({
        purchaseStepNumber: getPurchaseStepNumber(state),
        purchaseStrategyType: getPurchaseStrategyType(state),
        steps: getPurchaseSteps(state),
    }),
    (dispatch) => ({
        setPrevPurchaseStepNumber: bindActionCreators(setPrevPurchaseStepNumber, dispatch),
        setNextPurchaseStepNumber: bindActionCreators(setNextPurchaseStepNumber, dispatch),
        sendCompanyInfo: bindActionCreators(sendCompanyInfo, dispatch),
        getFreeLicense: bindActionCreators(getFreeLicense, dispatch),
        purchaseLicense: bindActionCreators(purchaseLicense, dispatch),
        closePurchasePopup: bindActionCreators(closePurchasePopup, dispatch),
        setAgreementsConfirmed: bindActionCreators(setAgreementsConfirmed, dispatch),
    })
)(PurchaseLightBox)



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/PurchaseLightBox.js